import { round } from 'lodash-es'

import { AnalyticsResult, UsageResult } from '@infura/packages.api'

const ONE_THOUSAND = 1_000
const TEN_THOUSAND = 10_000
const ONE_MILLION = 1_000_000
const ONE_BILLION = 1_000_000_000

export const getValueInTensOfThousands = (value: number) => {
  const valueInThousands = round(value / ONE_THOUSAND, 2)
  return `${valueInThousands}K`
}

export const getValueInThousands = (value: number, formatForTensOfThousand?: boolean) => {
  if (formatForTensOfThousand && value >= TEN_THOUSAND) return getValueInTensOfThousands(value)
  return value.toLocaleString('en-US')
}

export const getValueInMillions = (value: number) => {
  const valueInMillions = round(value / ONE_MILLION, 2)
  return `${valueInMillions}M`
}

export const getValueInBillions = (value: number) => {
  const valueInBillions = round(value / ONE_BILLION, 2)
  return `${valueInBillions}B`
}

export const getFormattedUsage = (value: number, formatForTensOfThousand?: boolean) => {
  const absValue = Math.abs(value)

  if (absValue >= ONE_BILLION) {
    return getValueInBillions(value)
  }

  if (absValue >= ONE_MILLION) {
    return getValueInMillions(value)
  }

  return getValueInThousands(value, formatForTensOfThousand)
}

export const getTotalUsage = ({
  data,
  mode = 'usage'
}: {
  data?: Array<UsageResult> | Array<AnalyticsResult>
  mode?: 'usage' | 'stats'
}) => {
  if (!data) {
    return null
  }
  const value =
    mode === 'usage'
      ? (data as Array<UsageResult>).reduce((acc, item) => acc + item.total, 0)
      : (data as Array<AnalyticsResult>).reduce((acc, item) => acc + item.value, 0)
  return { formatted: getFormattedUsage(value), value }
}
